











import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

import CardSelectTenant from '@/components/CardSelectTenant.vue'

import {
  addSupportUserInTenant,
  removeSupportUserFromTenant,
} from '@/services/supportUser'
import { getSupportUserCurrentLocale } from '@/services/users'
import { ITenant } from '@/types/types'

@Component({
  components: { CardSelectTenant },
})
export default class SupporUser extends Vue {
  currentTenant: ITenant = {}

  async onSelected(tenant: any) {
    this.setLoading(true)
    const user = await addSupportUserInTenant(tenant.tenantName)
    alert(`password: ${user.password}`)
    await this.refreshCurrentTenant()
    this.setLoading(false)
  }

  async onClean() {
    this.setLoading(true)
    await removeSupportUserFromTenant()
    await this.refreshCurrentTenant()
    this.setLoading(false)
  }

  async refreshCurrentTenant() {
    this.currentTenant = await getSupportUserCurrentLocale()
  }

  setLoading(value: boolean) {
    const cardSelectTenant = this.$refs.cardSelectTenant as CardSelectTenant
    cardSelectTenant.setLoading(value)
  }

  mounted() {
    this.setLoading(true)
    this.refreshCurrentTenant()
    this.setLoading(false)
  }
}
